import zhHans from 'vuetify/lib/locale/zh-Hans'
import global_config from '@/../config.json'

// Usage -> {{$vuetify.lang.t('$vuetify.close')}} -> 關閉
// zhHans language for has no longer be used because all intents has been setup on mandarin langauge also
export default {
  ...zhHans,
  __General: {
    submit: '提交'
  },
  __InitialLoading: {
    connecting: '连接中...'
  },
  __ChatBubbleAi: {
    default_answer_by: global_config.default_answer_by_zhHans || '此为人工智能生成的回答',
    default_answer_desc: global_config.default_answer_desc_zhHans || '此为人工智能生成的回答',
    answer_by_mrc: '此为人工智能生成的回答',
    mrc_answer_desc: '小慧运用人工智能学习了海关网页上的资料并根据你的查询为你建议最相关的页面。',
    answer_by_chatGPT: global_config.answer_by_chatGPT_zhHans || 'ChatGPT 智能回答',
    chatgpt_answer_desc: global_config.chatgpt_answer_desc_zhHans || 'ChatGPT 是一款由 OpenAI 开发的 AI 聊天机器人，透过自然语言处理技术生成模拟人类的对话内容。 ',
    prompt_bar_message: '以上的内容能帮到你吗？',
    comment_dialog: {
      title: '能说说您给这个评分的原因吗？',
      yes: '好的',
      no: '不用了',
      placeholder: '在此填写内容',
      remaining_character: '剩余字元: {0}/{1}',
      submit: '提交',
      closing: '感谢你的意见！'
    }
  },
  __Cards: {
    highly_relevant: '高度相关',
    moderately_relevant: '中等相关',
    slightly_relevant: '稍微相关',
    client_list: '客户名单',
    success_cases: '成功案例'
  },
  __ChatContainer: {
    today: '今天'
  },
  __InputBar: {
    placeholder: '输入讯息(不要输入任何个人资料哦!)',
    press_to_record: '按住录音',
    press_once_to_record: '轻按一下录音',
    recording_press_once_to_stop: '录音中...(轻按一下停止)',
    recording: '录音中...'
  },
  __Rating: {
    your_rating: '请评分',
    like: '喜欢',
    dislike: '不喜欢',
    field_placeholder: '能告诉我们您给这个评分的原因？',
    scale_rating_hint: '最高 5 分 ，最低 1 分'
  },
  __DateTime: {
    selected: '你已选择',
    select_date: '请选择日期',
    select_time: '请选择时间'
  },
  __Dropdown: {
    select: '请选择'
  }
}
